import { BackTop, Form, Layout, Spin, Button, Modal, Radio } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { ROUTER } from '../../constants/router';
import { useTranslation } from 'react-i18next';
import IconBack from '../../assets/Images/icons/icon-back';
import { useState } from 'react';
import { useBlocker } from '../../util/usePrompt';
import StepInit from './components/StepInit';
import StepWizard from 'react-step-wizard';
import Steps from './components/Steps';
import ModalDiscardChanges from '../../components/Shared/modal/discardChanges';
import { useDpiaContext } from './dpia.context';
import DPIAService from '../../services/DPIA.service';
import useNotify from '../../context/Notification/useNotify';
import { useEffect } from 'react';
import { IconSave } from './components/iconEmpty';
import classNames from 'classnames';
import usePermission from '../../hooks/usePermission';

const { Provider } = Form;

const DPIA = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(['translation', 'dpia']);
    const { id } = useParams();
    const notify = useNotify();
    const { isAuditor } = usePermission();

    useEffect(() => {
        if (isAuditor) {
            navigate(ROUTER.DPIA.DEFAULT);
        }
    }, [isAuditor, navigate]);

    const {
        ref,
        identificationList,
        setselectStatus,
        impact,
        dataflow,
        wizard,
        setError,
        setLoading,
        setStep1,
        setStep2,
        setStep3,
        setStep4,
        setStep5,
        setStep7,
        setSetselectStatus,
        status,
        setStep2State,
        stepNo,
    } = useDpiaContext();

    const [state, updateState] = useState();
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);
    const [initing, setIniting] = useState(false);
    const [open, setOpen] = useState(false);

    // init Master

    useEffect(() => {
        console.log('stepNo', stepNo);
        if (stepNo === 0) {
            const removeHash = () => {
                if (window.location.hash) {
                    navigate(
                        window.location.pathname + window.location.search,
                        { replace: true }
                    );
                    window.location.reload();
                }
            };
            removeHash();
            window.addEventListener('hashchange', removeHash);
            return () => {
                window.removeEventListener('hashchange', removeHash);
            };
        }
    }, [stepNo]);

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        console.log('nextLocation', nextLocation);
        setNextLocation(nextLocation);
    };

    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        console.log(
            'nextLocation.location.search',
            nextLocation.location.search
        );

        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const [initForm] = Form.useForm();
    const [identification] = Form.useForm(); // Step1
    const [description] = Form.useForm(); // Step2
    const [consultation] = Form.useForm(); // Step3
    const [necessaryProportionality] = Form.useForm(); // Step4
    const [riskAssessment] = Form.useForm(); // Step5
    const [measures] = Form.useForm(); // Step6
    const [planning] = Form.useForm(); // Step7
    const [monitoring] = Form.useForm(); // Step8
    const [dataflowList] = Form.useForm(); // DataflowList

    const mapSequence = (data) => {
        return data?.map((item, i) => {
            return {
                ...item,
                sequence: i + 1,
            };
        });
    };

    const genaratePayload = () => {
        const step1 = identification.getFieldsValue();
        const step2 = description.getFieldsValue();
        const step3 = consultation.getFieldsValue();
        const step4 = necessaryProportionality.getFieldsValue();
        const step5 = riskAssessment.getFieldsValue();
        const step6 = measures.getFieldsValue();
        const step7 = planning.getFieldsValue();
        const step8 = monitoring.getFieldsValue();
        const listIds = dataflowList.getFieldValue('dataflowList');

        const identificationListIncludes = identificationList.filter((obj) =>
            step1?.dpiaIdentificationList?.includes(obj.mDpiaIdentificationId)
        );

        const dpiaIdentificationList = identificationListIncludes?.map(
            (item, i) => {
                return {
                    mDpiaIdentificationId: item?.mDpiaIdentificationId,
                    dpiaIdentificationName: item?.dpiaIdentificationName,
                    sequence: i + 1,
                };
            }
        );

        const dpiaRiskAssessmentList = step5?.dpiaRiskAssessmentList?.map(
            (risk) => {
                const filteredObjects = impact.filter((obj) =>
                    risk?.dpiaRiskAssessmentImpactList?.includes(
                        obj.dpiaImpactOrganizeId
                    )
                );
                const dpiaRiskAssessmentImpactList = filteredObjects?.map(
                    (item, i) => {
                        return {
                            dpiaImpactOrganizeId: item.dpiaImpactOrganizeId,
                            dpiaRiskAssessmentImpactName:
                                item.dpiaImpactOrganizeName,
                            sequence: i + 1,
                        };
                    }
                );
                return {
                    ...risk,
                    dpiaRiskAssessmentImpactList,
                };
            }
        );

        const dpiaMitigatingMeasuresList =
            step6?.dpiaMitigatingMeasuresList || [];

        const dataflowIncludest = dataflow?.filter((obj) =>
            listIds?.includes(obj.businessProcessId)
        );

        const _dataflowList = mapSequence(dataflowIncludest);

        const _description = {
            contextDescription: mapSequence(step2?.contextDescription) || [],
            natureDescription: mapSequence(step2?.natureDescription) || [],
            purposeDescription: mapSequence(step2?.purposeDescription) || [],
            scopeDescription: mapSequence(step2?.scopeDescription) || [],
        };

        const payload = {
            identification: {
                ...step1,
                status: setselectStatus,
                dpiaIdentificationList,
            },
            description: _description,
            consultation: mapSequence(step3?.consultation) || [],
            necessaryProportionality:
                mapSequence(step4?.necessaryProportionality) || [],
            riskAssessment: {
                dpiaRiskAssessmentList,
            },
            measures: {
                dpiaMitigatingMeasuresList,
            },
            planning: {
                ...step7,
                startDate: step7?.startDate
                    ? moment(step7?.startDate).valueOf()
                    : '',
                endDate: step7?.endDate ? moment(step7?.endDate).valueOf() : '',
            },
            monitoring: step8,
            dataflowList: _dataflowList,
        };
        return payload;
    };

    const service = (payload) => {
        if (id === 'new') {
            return DPIAService.createDPIA(payload);
        } else return DPIAService.updateDPIA(payload);
    };

    const onSubmitForm = async () => {
        setIniting(true);

        let step1Valid = true;
        let step2Valid = true;
        let step3Valid = true;
        let step4Valid = true;
        let step5Valid = true;
        let step7Valid = true;

        try {
            const listIds = dataflowList.getFieldValue('dataflowList');
            try {
                await identification.validateFields();
            } catch (validationError) {
                step1Valid = false;
            }

            try {
                await description.validateFields();
            } catch (validationError) {
                step2Valid = false;
                const errorFields = validationError?.errorFields || [];
                const descriptionMap = {
                    natureDescription: 0,
                    scopeDescription: 1,
                    contextDescription: 2,
                    purposeDescription: 3,
                };
                const mappedErrors = errorFields
                    .map((field) => {
                        const descriptionName = field.name[0];
                        return descriptionMap[descriptionName] !== undefined
                            ? descriptionMap[descriptionName]
                            : null;
                    })
                    .filter((num) => num !== null);

                const uniqueSortedErrors = [...new Set(mappedErrors)].sort(
                    (a, b) => a - b
                );
                setStep2State({
                    value: uniqueSortedErrors[0],
                    timestamp: Date.now(),
                });
            }

            try {
                await consultation.validateFields();
            } catch (validationError) {
                step3Valid = false;
            }

            try {
                await necessaryProportionality.validateFields();
            } catch (validationError) {
                step4Valid = false;
            }

            try {
                await riskAssessment.validateFields();
            } catch (validationError) {
                step5Valid = false;
            }

            try {
                await planning.validateFields();
            } catch (validationError) {
                step7Valid = false;
            }

            if (
                step1Valid &&
                step7Valid &&
                step5Valid &&
                step3Valid &&
                step4Valid &&
                step2Valid
            ) {
                if (listIds?.length > 0) {
                    setLoading(true);
                    setOpen(true);
                    // const payload = genaratePayload();
                    // service(payload)
                    //     .then((res) => {
                    //         if (res.data.resultData) {
                    //             setChange(false);
                    //             setOpenChange(false);
                    //             setIniting(false);
                    //             notify({
                    //                 title: t('common.Success'),
                    //                 description: t('Successfully saved data'),
                    //             });
                    //             if (wizard?.SW?.state?.activeStep === 8)
                    //                 setTimeout(() => {
                    //                     navigate(ROUTER?.DPIA?.DEFAULT);
                    //                 }, 1000);
                    //             else {
                    //                 const hash = window.location.hash;
                    //                 navigate(
                    //                     `${ROUTER?.DPIA?.DEFAULT}/${res.data.resultData.dpiaId}${hash}`
                    //                 );
                    //             }
                    //         }
                    //     })
                    //     .catch((error) => {
                    //         console.log(error);
                    //         notify({
                    //             type: 'error',
                    //             title: t('common.Fail'),
                    //             description: t('common.FailedSaveData'),
                    //         });

                    //         setIniting(false);
                    //     });
                } else {
                    setError(true);
                    setIniting(false);
                    if (wizard?.SW?.state?.activeStep === 8)
                        wizard?.SW?.goToStep(1);
                }
            } else {
                if (!step1Valid) {
                    setStep1(false);
                    wizard?.SW?.goToStep(1);
                } else if (!step2Valid) {
                    setStep2(false);
                    wizard?.SW?.goToStep(2);
                } else if (!step3Valid) {
                    setStep3(false);
                    wizard?.SW?.goToStep(3);
                } else if (!step4Valid) {
                    setStep4(false);
                    wizard?.SW?.goToStep(4);
                } else if (!step5Valid) {
                    setStep5(false);
                    wizard?.SW?.goToStep(5);
                } else if (!step7Valid) {
                    setStep7(false);
                    wizard?.SW?.goToStep(7);
                }
                setIniting(false);
            }
        } catch (error) {
            console.log(error);
            setIniting(false);
            wizard?.SW?.goToStep(1);
        }
    };

    const onFormChange = (name, info) => {
        if (info.changedFields.length > 0) {
            setChange(true);
        }
    };

    const setInstance = (SW) => {
        updateState({
            ...state,
            SW,
        });
    };

    useEffect(() => {
        if (id !== 'new') {
            getDPIA(id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const getDPIA = async (id) => {
        try {
            setIniting(true);
            const { data } = await DPIAService.getDPIA(id);
            if (data?.resultData) {
                const initial = data.resultData;
                initForm.setFieldValue(
                    'dpiaName',
                    initial.identification?.dpiaName
                );
                const dpiaIdentificationList =
                    initial.identification?.dpiaIdentificationList?.map(
                        (id) => id.mDpiaIdentificationId
                    );

                identification.setFieldsValue({
                    ...initial.identification,
                    dpiaIdentificationList,
                });
                description.setFieldsValue(initial.description);
                consultation.setFieldsValue({
                    consultation: initial.consultation,
                });
                necessaryProportionality.setFieldsValue({
                    necessaryProportionality: initial.necessaryProportionality,
                });

                const dpiaRiskAssessmentList =
                    initial.riskAssessment?.dpiaRiskAssessmentList?.map(
                        (risk) => {
                            const dpiaRiskAssessmentImpactList =
                                risk?.dpiaRiskAssessmentImpactList.map(
                                    (id) => id?.dpiaImpactOrganizeId
                                );
                            return {
                                ...risk,
                                dpiaRiskAssessmentImpactList,
                            };
                        }
                    );
                riskAssessment.setFieldsValue({ dpiaRiskAssessmentList });

                const dpiaMitigating =
                    initial.measures?.dpiaMitigatingMeasuresList?.map(
                        (id) => id?.dpiaMitigatingMeasuresOrganizeId
                    );

                measures.setFieldsValue({
                    ...initial.measures,
                    dpiaMitigating,
                });
                const step7 = initial.planning;
                planning.setFieldsValue({
                    ...step7,
                    startDate: step7.startDate ? moment(step7.startDate) : null,
                    endDate: step7.endDate ? moment(step7.endDate) : null,
                });
                monitoring.setFieldsValue(initial.monitoring);
                const listId = initial.dataflowList?.map(
                    (id) => id.businessProcessId
                );
                dataflowList.setFieldsValue({ dataflowList: listId });
                setIniting(false);
            }
        } catch (error) {
            setIniting(false);
            console.log(error);
        }
    };

    const handleCancel = () => {
        setOpen(false);
        setIniting(false);
    };
    const submitForm = () => {
        console.log('submit');
        const payload = genaratePayload();
        service(payload)
            .then((res) => {
                if (res.data.resultData) {
                    setChange(false);
                    setOpenChange(false);
                    setIniting(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully saved data'),
                    });
                    if (wizard?.SW?.state?.activeStep === 8)
                        setTimeout(() => {
                            navigate(ROUTER?.DPIA?.DEFAULT);
                        }, 1000);
                    else {
                        const hash = window.location.hash;
                        navigate(
                            `${ROUTER?.DPIA?.DEFAULT}/${res.data.resultData.dpiaId}${hash}`
                        );
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });

                setIniting(false);
            });
    };
    const handleOk = () => {
        submitForm();
        setOpen(false);
    };
    return (
        <div className="relative">
            <div className="title flex items-center">
                <button
                    type="button"
                    className="cursor-pointer mr-3 space-x-2"
                    onClick={() => {
                        navigate(`${ROUTER.DPIA.DEFAULT}`);
                    }}
                >
                    <IconBack />
                    <span>
                        {id === 'new'
                            ? t('Create DPIA', {
                                  ns: 'dpia',
                              })
                            : t('Edit DPIA', {
                                  ns: 'dpia',
                              })}
                    </span>
                </button>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">{t('DPIA')} / </span>
                <span>
                    {id === 'new'
                        ? t('Create DPIA', {
                              ns: 'dpia',
                          })
                        : t('Edit DPIA', {
                              ns: 'dpia',
                          })}
                </span>
            </div>
            {/* <Tour closeIcon={false} open={open} steps={steps} /> */}
            <Spin spinning={initing}>
                <Provider onFormChange={onFormChange}>
                    <StepWizard instance={setInstance}>
                        <StepInit form1={identification} form={initForm} />
                        <Steps
                            identification={identification}
                            description={description}
                            consultation={consultation}
                            necessaryProportionality={necessaryProportionality}
                            riskAssessment={riskAssessment}
                            measures={measures}
                            planning={planning}
                            monitoring={monitoring}
                            dataflowList={dataflowList}
                        />
                    </StepWizard>
                </Provider>
            </Spin>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
                title={t('common.DiscardChanges2')}
                text={t('common.DiscardChangesText2')}
            />
            <button ref={ref} onClick={onSubmitForm} hidden />
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
            <Modal
                className="_modal"
                centered
                closable={false}
                open={open}
                onCancel={handleCancel}
                footer={false}
                width={400}
            >
                <div className="text-center m-auto">
                    <IconSave />
                    <div className="text-1xl font-semibold">
                        {t('Save data')}
                    </div>
                    <div>
                        {t('What is the current status of DPIA', {
                            ns: 'dpia',
                        })}
                    </div>
                    {status?.length > 0 && (
                        <Radio.Group
                            value={setselectStatus}
                            className="space-y-2 my-4"
                            onChange={({ target: { value } }) => {
                                setSetselectStatus(value);
                            }}
                        >
                            {status?.map((status) => (
                                <Radio
                                    className={classNames(
                                        'border-solid border rounded-lg p-2 shadow-md w-80',
                                        {
                                            'border-[#DBDBDB]':
                                                setselectStatus !==
                                                status.statusId,
                                            'border-[#7B67FB]':
                                                setselectStatus ===
                                                status.statusId,
                                        }
                                    )}
                                    key={status.statusId}
                                    value={status.statusId}
                                    style={{ lineHeight: '32px' }}
                                >
                                    {i18n.language === 'en'
                                        ? status.nameEn
                                        : status.nameTh}
                                </Radio>
                            ))}
                        </Radio.Group>
                    )}
                    <div className="py-4">
                        <Button
                            ghost
                            type="primary"
                            size="large"
                            className="px-10 mr-2"
                            onClick={handleCancel}
                        >
                            {t('Cancel')}
                        </Button>
                        <Button
                            onClick={handleOk}
                            type="primary"
                            size="large"
                            className="px-10"
                        >
                            {t('Submit')}
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

export default DPIA;
